// A comma is the delimiter used when multiple groups are sent via managed config,
// so it must not be part of a device group name.
export const INVALID_GROUP_NAME = 'InvalidName'
export const GROUP_NAME_COMMA_MESSAGE = 'Group name cannot contain a comma (,)'

export const hasComma = (name) => typeof name === 'string' && name.includes(',')
